module.exports = __webpack_public_path__ + "media/images/prescreen_empty_state-5cc9ab33dba2df5f8d37c2294f5fd288.svg";